﻿import * as React from "react";

export interface IThematicBreakProps {
    className?: string;
}

export const ThematicBreak: React.FunctionComponent<IThematicBreakProps> = (
    props,
): React.ReactElement => <hr className={`thematicbreak ${props.className}`} />;
